const REGIMENES_DIAS_COMPLETOS = ['construccion', 'agrario', 'servicio_domestico']

function parseDiasCandidate(value) {
  if (value === null || value === undefined) return null
  const txt = String(value).trim()
  if (!txt) return null
  const fixed = txt.replace(/[oO]/g, '0').replace(/[^0-9-]/g, '')
  if (!fixed) return null
  const n = Number(fixed)
  if (!Number.isFinite(n)) return null
  return Math.trunc(n)
}

export function pickDiasFromSource(raw = {}) {
  const candidates = [
    raw.dias,
    raw.diasPeriodo,
    raw.dias_periodo,
    raw.diasTrabajados,
    raw.days,
    raw.dayCount,
  ]
  for (const candidate of candidates) {
    const parsed = parseDiasCandidate(candidate)
    if (parsed !== null) return parsed
  }
  return null
}

function normalizeDiasRule(diasOrigen, regimenEspecial, rowContext = {}) {
  if (!Number.isInteger(diasOrigen) || diasOrigen <= 0) {
    // Gap #1: Era no digitalizada (07/1994 ~ 2003) — ANSES muestra 0 días
    //         como placeholder. Para Dependencia, asumimos mes completo (30d previsional).
    if (rowContext.tipo === 'Dependencia') {
      const ano = Number(rowContext.ano) || 0
      const mes = Number(rowContext.mes) || 0
      const periodoNum = ano * 100 + mes
      if (periodoNum >= 199407 && periodoNum <= 200312) {
        return {
          diasOrigen: diasOrigen,
          diasComputables: 30,
          reglaAplicada: 'full_month_non_digitized_era',
          requiereRevisionDias: true,
        }
      }
    }
    return {
      diasOrigen: null,
      diasComputables: null,
      reglaAplicada: 'sin_dato',
      requiereRevisionDias: true,
    }
  }
  if (diasOrigen === 30) {
    return {
      diasOrigen,
      diasComputables: 30,
      reglaAplicada: 'mes_completo_30',
      requiereRevisionDias: false,
    }
  }
  if (REGIMENES_DIAS_COMPLETOS.includes(regimenEspecial) && diasOrigen >= 20) {
    return {
      diasOrigen,
      diasComputables: 30,
      reglaAplicada: 'mes_completo_regimen_especial',
      requiereRevisionDias: true,
    }
  }
  if (diasOrigen < 30) {
    return {
      diasOrigen,
      diasComputables: diasOrigen,
      reglaAplicada: 'mes_incompleto_dias_exactos',
      requiereRevisionDias: false,
    }
  }
  return {
    diasOrigen,
    diasComputables: null,
    reglaAplicada: 'dias_fuera_rango',
    requiereRevisionDias: true,
  }
}

export function normalizarDiasAnses(remuneracionesMapeadas = []) {
  return remuneracionesMapeadas.map((row) => {
    const diasExtraidos = row.diasOrigenRaw ?? pickDiasFromSource(row)
    const normalized = normalizeDiasRule(diasExtraidos, row.regimenEspecial, row)
    return {
      ...row,
      diasOrigen: normalized.diasOrigen,
      diasComputables: normalized.diasComputables,
      reglaAplicadaDias: normalized.reglaAplicada,
      requiereRevisionDias: normalized.requiereRevisionDias,
      fuenteDias: diasExtraidos === null ? 'sin_columna_dias' : 'document_ai_tabla',
    }
  })
}
